import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
    return (
        <footer className="bg-primary text-primary-foreground py-12 mt-auto" data-testid="footer">
            <div className="container-main">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div>
                        <img 
                            src="https://customer-assets.emergentagent.com/job_video-rebuild-2/artifacts/96keensf_Zarolla_logo_final_allwhite_nosub.png" 
                            alt="Zarolla Online Art Academy" 
                            className="h-10 mb-4"
                        />
                        <p className="text-primary-foreground/70 text-sm leading-relaxed">
                            Professional art education from master artists. 
                            Oil painting, portraiture, figure drawing, and sculpture.
                        </p>
                    </div>

                    {/* Catalog */}
                    <div>
                        <h4 className="font-medium text-sm uppercase tracking-wider mb-4">
                            Catalog
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/courses" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Courses
                                </Link>
                            </li>
                            <li>
                                <Link to="/workshops" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Painting Videos
                                </Link>
                            </li>
                            <li>
                                <Link to="/sculptures" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Sculpture Videos
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Academy */}
                    <div>
                        <h4 className="font-medium text-sm uppercase tracking-wider mb-4">
                            Academy
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/about" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                                    Terms of Service
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-medium text-sm uppercase tracking-wider mb-4">
                            Support
                        </h4>
                        <p className="text-primary-foreground/70 text-sm">
                            Questions about courses or your account?
                        </p>
                        <Link 
                            to="/contact"
                            className="text-primary-foreground hover:text-accent text-sm mt-2 inline-block transition-colors"
                        >
                            Contact Support →
                        </Link>
                    </div>
                </div>

                <div className="border-t border-primary-foreground/20 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-primary-foreground/50 text-sm">
                        © {new Date().getFullYear()} Zarolla Online Art Academy. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        <Link to="/privacy" className="text-primary-foreground/50 hover:text-primary-foreground/80 text-sm transition-colors">
                            Privacy
                        </Link>
                        <Link to="/terms" className="text-primary-foreground/50 hover:text-primary-foreground/80 text-sm transition-colors">
                            Terms
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
